module.exports = __webpack_public_path__ + "static/media/top_arrow_blue.aa9c77f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/top_arrow_blue.svg
// module id = ./src/assets/media/forum/top_arrow_blue.svg
// module chunks = 16